// General
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button, Grid } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import Link from '../Link';

import messages from '../../locale/jsonMessages';

import s from './CookiesDisclaimer.css';

const CookiesDisclaimer = () => {

  const siteName = useSelector(state => state?.siteSettings?.data?.siteName);
  const intl = useIntl();
  const { formatMessage } = intl;

  const [isCookiesSet, setIsCookiesSet] = useState(false);
  const [isPageLoad, setIsPageLoad] = useState(false);

  useEffect(() => {
    const cookies = new Cookies();
    const cookiesValue = cookies.get('cookiesDisclaimer');
    setIsCookiesSet(cookiesValue ? true : false);
    setIsPageLoad(true);
  }, []
  )

  const disclaimerForm = () => {
    let maxAge = 3650 * 24 * 365;
    const cookies = new Cookies(null, { path: '/', maxAge });
    cookies.set('cookiesDisclaimer', 'RentallDisclaimer');
    setIsCookiesSet(true)
  }

  if (isCookiesSet) {
    return <div></div>;
  } else {
    return (
      <Grid fluid className={'hidden-print'}>
        {
          isPageLoad && <div
            className={cx(s.root, s.container, s.fixedPosition)}
          >
            <div className={cx(s.cookiesBackground)}>
              <div>
                <div className={cx(s.displayTable, s.displayTableSection)}>
                  <div className={s.displayRow}>
                    <div className={s.displayText}>
                      <span className={cx(s.labelText)}>
                        {siteName}{' '}
                        {formatMessage(messages.cookiesDisclaimer)}
                        {' '}
                        <Link to={'/cookie-policy'} className={cx(s.labelText, s.linkStyle)}>{formatMessage(messages.cookiePolicy)}</Link>
                      </span>
                    </div>

                    <div className={cx(s.displayBtn)}>
                      <Button
                        type="button"
                        className={cx(s.button)}
                        onClick={disclaimerForm}
                      >
                        {formatMessage(messages.gotIt)}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        }
      </Grid>
    )
  }
}
CookiesDisclaimer.propTypes = {
  formatMessage: PropTypes.func,
};

export default (withStyles(s)(CookiesDisclaimer));